import baseTheme from '../baseTheme';
export var MuiSelect = {
    select: {
        '&:focus, &.Mui-focused': {
            backgroundColor: 'transparent',
            '& > $icon': {
                transform: 'rotate(180deg)',
            },
        },
    },
    iconOutlined: {
        // specificity hack
        '&&': {
            right: baseTheme.spacing(2),
            top: 'calc(50% - 8px)',
            fontSize: baseTheme.typography.pxToRem(14),
        },
    },
};
//# sourceMappingURL=MuiSelect.js.map